import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRealtorRatingListFailed, EGetRealtorRatingActionType } from './types';

export const getRealtorRatingListFailed: () => TGetRealtorRatingListFailed =
  actionGenerator<EGetRealtorRatingActionType.Failed>(EGetRealtorRatingActionType.Failed);
